var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"serviceTerms"},[_c('Navbar',{attrs:{"title":"用户服务条款","default-bg":false}}),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.$xss(_vm.text))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }